import { BaseQueryFn, createApi, EndpointBuilder, EndpointDefinitions, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

import type { GetMeParams, GetMeResponse } from "@hz/stealthy-gmc-cloaker-common/api-types/auth";
import  baseQuery from "./baseQuery";
import { Tags as T } from "./tags";

export const Tags = T;

export const api = createApi({
  reducerPath: "apiSlice",
  baseQuery: baseQuery,
  endpoints: (build) => ({
    init: build.query<GetMeResponse, {}>({
      query: () => ({
        url: `/auth/me`,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

  }),
  tagTypes: [
    Tags.Auth,
    Tags.Stores,
    Tags.IPs,
    Tags.Users,
  ]
});

export type ApiEndpoints = typeof api.endpoints;
